import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Order, OrderExchange } from '@shared-logic/orders';
//import { DataIBM } from '../../../../shared-logic/integration-ibm/interfaces/responseIBM.interface';
import { environment } from 'src/environments/environment';
import { appState } from '../interfaces/appState.interface';
import { User } from '@shared-logic/user';
import { addLoaderSendToIBM, discountLoaderSendToIBM } from 'src/app/redux/actions/order.action';
import { ContractProcessResult } from '@shared-logic/integration-ibm';
import { addModalContractFailed, addModalContractSuccess, setModalContractType } from 'src/app/redux/actions/options.action';
import { typeOfModal } from '../const/options';

@Injectable({
  providedIn: 'root',
})
export class IntegrationIBMService {
  private store = inject(Store<appState>);

  constructor(private http: HttpClient) { }

  createContracts(orders: Order[], nroOfCall: number, user: User) {
    if (orders.length > 0 && user.email) {
      this.store.dispatch(addLoaderSendToIBM());

      const url = `${environment.rutas.ibm.createContractBackend}/contracts/from-order`;

      this.http.post<ContractProcessResult[]>(url, { orders, nroOfCall }).subscribe({
        next: (response: ContractProcessResult[]) => {
          this.store.dispatch(discountLoaderSendToIBM()); // Quitamos el loader
          if (Array.isArray(response)) {
            response.forEach(res => this.openModal(res, nroOfCall, false));
          } else {
            // In case backend changes behavior or single object
            // Ideally backend always returns array as per handler
            this.openModal(response as any, nroOfCall, false);
          }
          console.log("Respuesta del backend:", response);
        },
        error: (error: any) => {
          console.error("Error al crear contrato:", error);
          this.store.dispatch(discountLoaderSendToIBM());

          if (error.error && Array.isArray(error.error)) {
            error.error.forEach((err: ContractProcessResult) => this.openModal(err, nroOfCall, false));
          } else {
            // Fallback
            const errorResponse: ContractProcessResult = {
              status: 'error',
              message: 'Error de conexión o inesperado',
              orderId: '',
              contractNumber: 0
            };
            this.openModal(errorResponse, nroOfCall, false);
          }
        }
      });
    }
  }

  // nroOfCall is implicitly handled by backend for exchange (always 1 -> full flow) 
  // but we might want to flag the type of modal (Draft or Contract).
  // Exchange flow creates Draft AND Contract in one go if successful.
  // So we typically show it as Contract (type 2 or similar).
  createContractExchangeSvc(order: OrderExchange, user: User, nroOfCall: number) {
    if (user.email) {
      this.store.dispatch(addLoaderSendToIBM());
      const url = `${environment.rutas.ibm.createContractBackend}/contracts/from-exchange`;

      // Backend expects { orders: [] }
      this.http.post<ContractProcessResult[]>(url, { orders: [order] }).subscribe({
        next: (response: ContractProcessResult[]) => {
          this.store.dispatch(discountLoaderSendToIBM());
          if (Array.isArray(response)) {
            response.forEach(res => this.openModal(res, 2, true)); // Assume 2 (Contract) for exchange completion
          } else {
            this.openModal(response as any, 2, true);
          }
          console.log("Respuesta del backend Exchange:", response);
        },
        error: (error: any) => {
          console.error("Error al crear canje:", error);
          this.store.dispatch(discountLoaderSendToIBM());
          if (error.error && Array.isArray(error.error)) {
            error.error.forEach((err: ContractProcessResult) => this.openModal(err, 2, true));
          } else {
            const errorResponse: ContractProcessResult = {
              status: 'error',
              message: 'Error de conexión o inesperado',
              orderId: order._id,
              contractNumber: 0
            };
            this.openModal(errorResponse, 2, true);
          }
        }
      });
    }
  }

  openModal(response: ContractProcessResult, nroOfCall: number, isExchange: boolean = false) {
    if (response.status == 'error') {
      //Al array de faileds que teníamos anteriormente, le agregamos la nueva respuesta
      this.store.dispatch(addModalContractFailed({ arrayOfFaileds: [response], isIndicators: false }));
      this.store.dispatch(setModalContractType({ typeModal: typeOfModal.ERROR }));

    } else if (response.status == 'ok') {
      if (nroOfCall == 1 && !isExchange) {
        this.store.dispatch(addModalContractSuccess({ arrayOfSuccess: [response] }));
        this.store.dispatch(setModalContractType({ typeModal: typeOfModal.ERASER }));
      } else if (nroOfCall == 2 || isExchange) {
        // Exchange always ends in contract if OK (or draft if partial, but let's assume contract for now based on backend logic)
        // Backend Exchange flow sets status=COMPLETA and returns OK if both steps passed.
        this.store.dispatch(addModalContractSuccess({ arrayOfSuccess: [response] }));
        this.store.dispatch(setModalContractType({ typeModal: typeOfModal.CONTRACT }));
      }
    }
  }
}